import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import ConfirmDialogComponent from '../../common/confirmDialog.component';
import { deleteSession } from '../../../store/actions/session.actions';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
  deleteSession: {
    float: 'right',
    color: theme.palette.red,
  },
});

class DeleteSessionButtonContainer extends React.Component {
  constructor(props) {
    super(props);

    this.deleteSession = this.deleteSession.bind(this);

    this.state = {
      isDeleting: false,
    };
  }

  deleteSession(e) {

    const { sessionId } = this.props;

    this.setState({ isDeleting: true });
    this.props.deleteSession(sessionId);
    this.props.callback();
  }

  render() {
    const { classes, label, callback } = this.props;

    return (
      <ConfirmDialogComponent
        title="Are you sure?"
        bodyText="Do you want to delete the item?"
        action={this.deleteSession}
        cancelCallback={callback}
      >
        <Button
          color="primary"
          className={classes.deleteSession}
          disabled={this.state.isDeleting}
        >
          <Icon className={classes.icon}>delete</Icon>
          {label}
        </Button>
      </ConfirmDialogComponent>
    );
  }
}

DeleteSessionButtonContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  deleteSession: PropTypes.func.isRequired,
  callback: PropTypes.func,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

DeleteSessionButtonContainer.defaultProps = {
  callback: () => null,
};

export default withStyles(styles)(connect(
  null,
  { deleteSession },
)(DeleteSessionButtonContainer));
